import { computed, onBeforeMount } from "@vue/composition-api";
import { useAccountStoreGetters, useAccountStoreActions } from "@Broker/@Modules/main/store/account/account-helpers";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import * as AccountActions from "@Broker/@Modules/main/store/account/account-actions";
import { cloneDeep } from "lodash";
export const useReportDefaultSettings = ({
  reportType,
  reportDataRef
}) => {
  const {
    GET_REPORT_DEFAULT_SETTINGS
  } = useAccountStoreGetters([AccountGetters.GET_REPORT_DEFAULT_SETTINGS]);
  const currentReportDefaults = computed(() => GET_REPORT_DEFAULT_SETTINGS.value[reportType]);
  const renewalTrackingToLocal = () => {
    const {
      agents: agent,
      level,
      lender,
      groupBy,
      sortByPrimary,
      sortBySecondary,
      maturityDateFrom: dateFrom,
      maturityDateTo: dateTo,
      mortgageType,
      requestType,
      format
    } = currentReportDefaults.value;
    return {
      agent,
      format: format,
      level,
      lender,
      mortgageType,
      requestType,
      groupBy,
      sortBy: [sortByPrimary, sortBySecondary],
      dateFrom,
      dateTo
    };
  };
  const applicationSummaryToLocal = () => {
    return currentReportDefaults.value;
  };
  const firmStatisticsToLocal = () => {
    const {
      agents: selectedAgents,
      level: selectedLevel,
      dateFrom,
      dateTo,
      dateType,
      applicationStatus: selectedApplicationStatus,
      annualInformationReturn: filterForAIR,
      format
    } = currentReportDefaults.value;
    return {
      dateType,
      dateFrom,
      dateTo,
      selectedLevel,
      selectedAgents,
      selectedApplicationStatus,
      selectedFormat: format,
      filterForAIR
    };
  };
  const lenderTransactionToLocal = () => {
    const {
      agents: agent,
      level,
      lender,
      groupBy,
      sortByPrimary,
      sortBySecondary,
      dateFrom,
      dateTo,
      dateType,
      applicationStatus,
      annualInformationReturn: filterForAIR,
      format
    } = currentReportDefaults.value;
    return {
      agent,
      format: format,
      level,
      lender,
      groupBy,
      sortBy: [sortByPrimary, sortBySecondary],
      dateFrom,
      dateTo,
      dateType,
      applicationStatus,
      filterForAIR
    };
  };
  const commissionsToLocal = () => {
    return currentReportDefaults.value;
  };
  const riskLevelToLocal = () => {
    const {
      agents: selectedAgents,
      level: selectedLevel,
      dateFrom,
      dateTo,
      dateType,
      applicationStatus: selectedApplicationStatus,
      riskLevels: selectedRiskLevels,
      format
    } = currentReportDefaults.value;
    return {
      selectedAgents,
      selectedLevel,
      dateFrom,
      dateTo,
      dateType,
      selectedApplicationStatus,
      selectedRiskLevels,
      selectedFormat: format
    };
  };
  const reportToLocalMappers = {
    applicationSummary: applicationSummaryToLocal,
    firmStatistics: firmStatisticsToLocal,
    renewalTracking: renewalTrackingToLocal,
    lenderTransactions: lenderTransactionToLocal,
    commissions: commissionsToLocal,
    riskLevel: riskLevelToLocal
  };
  const loadReportDefaultValues = () => {
    reportDataRef.value = cloneDeep(reportToLocalMappers[reportType]());
  };
  onBeforeMount(() => {
    loadReportDefaultValues();
  });
  const {
    UPDATE_DEFAULT_REPORTS_PREFERENCE
  } = useAccountStoreActions([AccountActions.UPDATE_DEFAULT_REPORTS_PREFERENCE]);
  const updateReportDefaults = async reportData => {
    const reportDataClone = cloneDeep(reportData);
    return UPDATE_DEFAULT_REPORTS_PREFERENCE({
      [reportType]: reportDataClone
    });
  };
  return {
    loadReportDefaultValues,
    updateReportDefaults
  };
};